import { forwardRef } from 'react';
import { InputText } from 'primereact/inputtext';
import "./InputBox.scss";

const InputBox = forwardRef(({
    fieldName = "default",
    fieldType = "text",
    placeholder = "",
    styles = {},
    value = "",
    handleChange = () => { },
    inputStyles = {},
    labelStyles = {},
    errorStyles = {},
    customLabelName = "",
    autoComplete = "on",
    required = false,
    hasError = false,
    keyFilter= null,
    maxLength 
}, ref) => {

    const labelName = fieldName
        ? fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase() + ":"
        : "Field Name";

    return (
        <div style={styles} className="InputContainer">
            <label
                htmlFor={fieldName}
                style={labelStyles}
                className="label"
            >
                {customLabelName ? customLabelName : labelName}
                {required && <sup style={{ fontWeight: "700", color: "red", fontSize: "1.3rem" }}>*</sup>}
            </label>
            <InputText
                id={fieldName}
                name={fieldName}
                onChange={handleChange}
                value={value}
                style={inputStyles}
                type={fieldType}
                placeholder={placeholder}
                ref={ref}
                autoComplete={autoComplete}
                className={hasError ? 'my-invalid' : ''}
                keyfilter={keyFilter}
                maxLength={maxLength}

            />
        </div>
    );
});

export default InputBox;
